import { Container, Button, Text, Tabs } from '@mantine/core';
import { Link } from 'react-router-dom';
import { IconPlus, IconTicket, IconCheck, IconHeadphones } from '@tabler/icons-react';
import SupportTicketList from '../components/package/SupportTicketList';
import PageTitle from '../components/common/PageTitle';

const Tickets = () => {
  return (
    <Container size="lg">
      <PageTitle
        title="Support Tickets"
        description="View and manage your support tickets. Track the status of your inquiries and respond to messages from our support team."
        icon={<IconHeadphones size={24} />}
        breadcrumbs={[
          { title: 'Dashboard', href: '/dashboard' },
          { title: 'Support Tickets' }
        ]}
        actions={
          <Button
            component={Link}
            to="/help?tab=ticket"
            leftSection={<IconPlus size="1rem" />}
            size="sm"
          >
            Create New Ticket
          </Button>
        }
        withBorder
      />

      <Tabs defaultValue="active">
        <Tabs.List mb="md">
          <Tabs.Tab
            value="active"
            leftSection={<IconTicket size="0.8rem" />}
          >
            Active Tickets
          </Tabs.Tab>
          <Tabs.Tab
            value="resolved"
            leftSection={<IconCheck size="0.8rem" />}
          >
            Resolved Tickets
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="active">
          <SupportTicketList />
        </Tabs.Panel>

        <Tabs.Panel value="resolved">
          <Text c="dimmed" ta="center" py="xl">
            Resolved tickets will be displayed here.
          </Text>
        </Tabs.Panel>
      </Tabs>
    </Container>
  );
};

export default Tickets;
